module.exports = __webpack_public_path__ + "static/media/Feature1.aac6754a.png";